import { createSelector } from 'reselect';

export const getUserLikesMap = (state) => state.userLikes.map;

const getIdList = (state, idList) => idList;

export const getUserLikesByIdList = createSelector([getUserLikesMap, getIdList], (likesMap, idList) =>
  idList.map((id) => likesMap[id]),
);

export const getUserLikesCount = (state) => state.userLikes.metadata.count;

export const getUserLikesIdList = (state) => state.userLikes.idList;

export const getUserLikes = (state) => getUserLikesByIdList(state, getUserLikesIdList(state));
